<template>
  <div class="p-grid p-col-12">
    <div class="p-col-12 no-padding-margin-bottom-top" :class="{'p-md-7 p-lg-7' : loggedUser.typeUser !== limited}">

      <card class="p-col-12" :header="$t('protocol.my-protocols')" >
        <short-protocol-list v-if="currentUser" class="small" :default-filter="{'current_user': currentUser.id, 'status': ACTIVE}"/>
      </card>

      <card class="p-col-12 force-mb-0" :header="$t('protocol.all-protocols')">
        <div class="p-col-12" style="text-align: right;">
          <Button class="p-button-outlined p-mr-2 p-mb-2" @click.prevent="openFilterModal()">
            <i class="p-mr-2 pi pi-filter" /> {{$t('dataTable.protocol.filters')}}
          </Button>
        </div>
        <short-protocol-list v-if="currentUser" :key="defaultProtocolListFilter.budget" :default-filter="defaultProtocolListFilter" class="small" ref="allprotocolList" :quantity-per-page="10"/>
      </card>

    </div>

    <div class="p-col-12 p-md-5 p-lg-5 no-padding-margin-bottom-top" v-if="loggedUser.typeUser !== limited">
<!--      <card class="p-col-12 force-mt-0" :header="$t('protocol.information')">

      </card>-->

      <card class="p-col-12" :header="$t('protocol.fast-protocol-creator')">

        <div v-for="quickProtocol in quickProtocolsList" :key="quickProtocol.id" class="p-col-12">
          <box-card>
            <div>
              <Button icon="pi pi-plus small" class="p-button-rounded small-rounded-button" :title="$t('dataTable.protocol.add')" @click.prevent="addProtocol(quickProtocol)" />
            </div>
            <div class="p-col-10" style="font-size: medium">
              {{quickProtocol.name}}
            </div>
          </box-card>
        </div>

      </card>
    </div>

	</div>
</template>

<script>

import ShortProtocolList from "@/viewer/dashboard-components/ShortProtocolList";
import AuthBusiness from "@/business/AuthBusiness";
import BoxCard from "@/components/box/BoxCard";
import QuickProtocolCreateBusiness from "@/business/QuickProtocolCreateBusiness";
import DialogService from "@/business/ModalBusiness";
import FrontBusiness from "@/business/FrontBusiness";
import ModalCreateQuickProtocol from "@/viewer/protocol/ModalCreateQuickProtocol";
import store from "@/store";
import {LIMITED} from "@/constants/TypeUser";
import {ACTIVE} from "@/constants/StatusProtocol";

export default {
  components: {BoxCard, ShortProtocolList},

  data() {
		return {
      ACTIVE: ACTIVE,
      limited: LIMITED,
      loggedUser: store.getLoggedUser(),
      currentUser: null,
      quickProtocolsList: [],
      defaultProtocolListFilter: {
        status: ACTIVE,
        budget: null,
      },
      options: [
        {value: true, label: 'dataTable.protocol.columns.budget'},
        {value: false, label: 'dataTable.protocol.columns.protocol'},
        {value: null, label: 'btn.all'}
      ]
		}
	},

  async mounted() {
    this.currentUser = await AuthBusiness.getLoggedUser();
    this.quickProtocolsList = await QuickProtocolCreateBusiness.getAllActive();
  },

  methods: {

    async addProtocol(quickProtocol){
      const protocolId = await DialogService.openModal(ModalCreateQuickProtocol, {quickProtocol});
      if(protocolId) {
        FrontBusiness.redirect(`/protocol/${protocolId}`);
      }
    },

    async openFilterModal(){
      await this.$refs.allprotocolList.openFilterModal();
    },

    updateDefaultFilter(event) {
      this.$set(this.defaultProtocolListFilter, 'budget', event);
    }

  }

}
</script>

<style scoped>

</style>
